export default __webpack_public_path__ + "static/media/payment.35003269.svg";